function Stats({ counters, type, skeleton = false }) {
    const descriptions = {
      gateways: {
        total: 'Total number of gateways',
        active: 'Total number of active gateways',
        fail: 'Total number of failed gateways',
        init: 'Total number of initialization state gateways',
        error: 'Total number of error gateways',
      },
      devices: {
        total: 'Total number of devices',
        active: 'Total number of active devices',
        fail: 'Total number of failed devices',
        init: 'Total number of initialization state devices',
        error: 'Total number of error devices',
      },
    };
  
    const data = counters?.length
      ? [
          {
            title: 'total',
            value: counters[0].total,
            description: descriptions[type].total,
          },
          {
            title: 'active',
            value: counters[0].active,
            description: descriptions[type].active,
          },
          {
            title: 'fail',
            value: counters[0].fail,
            description: descriptions[type].fail,
          },
          {
            title: 'init',
            value: counters[0].init,
            description: descriptions[type].init,
          },
          {
            title: 'error',
            value: counters[0].error,
            description: descriptions[type].error,
          },
        ]
      : [];
  
    return (
      <div className="stats shadow container-outer-shadow bg-[var(--gradientPrimary)] mt-10 max-w-full w-full overflow-auto">
        {skeleton
          ? Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className="stat place-items-center animate-pulse">
                <div className="skeleton animate-pulse bg-[var(--skeleton-bg)] h-4 w-20 rounded"></div>
                <div className="skeleton animate-pulse bg-[var(--skeleton-bg)] h-8 w-14 rounded mt-2"></div>
                <div className="skeleton animate-pulse bg-[var(--skeleton-bg)] h-4 w-28 rounded mt-1"></div>
              </div>
            ))
          : data.map((stat, index) => (
              <div key={index} className="stat place-items-center">
                <div className="stat-title italic font-bold">{stat.title.toUpperCase()}</div>
                <div className="stat-value">{stat.value}</div>
                <div className="stat-desc">{stat.description}</div>
              </div>
            ))}
      </div>
    );
  }
  
  export default Stats;
  